export default {
  subtitle: "Credit card transactions Brazil",
  path: "transaction_3ds_cc_br",
  paragraphs: [
    "For Brazil you will create a credit card transaction calling our API, using the from_credit_card field. Check the payload below to see.",
    "For sandbox, you can use a checkout page sample available on our portal or via the following link. This page will help you understand the needed information and the whole flow from the credit transactions.",
    "We highly recommend testing the checkout page first before initiating direct API calls, because you can adapt it to your front-end environment.",
    "To create using the API call you will use the following endpoint: "
  ],
  hyperlink: {
    linkPath: "/static/3DSSamplesBR.zip",
    linkText: "Download sample page"
  },
  request: {
    method: "POST",
    endpoint: "/transactions",
    payload: {
      "transaction": {
        "currency": "BRL",
        "exchange_currency": "BRL",
        "value": "125.00",
        "from_credit_card": {
          "card_type": "credit",
          "card_number": "4000000000001091",
          "card_expiration_date": "01/2034",
          "card_security_code": "395",
          "card_brand": "master",
          "fullname": "Jose Silva"
        },
        "threeds": {
          "softDescriptor": "FacilitaPay",
          "httpAcceptBrowserValue": "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
          "httpBrowserLanguage": "en-US",
          "httpBrowserJavaEnabled": "false",
          "httpBrowserJavaScriptEnabled": "true",
          "httpBrowserColorDepth": "24",
          "httpBrowserScreenHeight": "969",
          "httpBrowserScreenWidth": "1250",
          "httpBrowserTimeDifference": "240",
          "userAgentBrowserValue": "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/138.0.0.0 Safari/537.36",
          "ipAddress": "127.0.0.1",
          "challengeWindowSize": "250x400"
        },
        "to_bank_account_id": "3686155e-f5f6-4e5b-97e7-60473a506b8c",
        "subject_id": "6b724825-ce7e-4da2-9def-d75957fee745",
        "meta": {
          "version": 2,
          "df_reference_id": "0_165b7a2f-359a-4efb-aae2-6e09cb786cf9",
          "mcc": "8999"
        }
      }
    },
    responses: {
      "data": {
        "value": "125.00",
        "to_bank_account": {
          "routing_number": null,
          "owner_name": "Biriweb Serviços de Internet Ltd",
          "owner_document_number": "12345678901",
          "owner_company": {
            "social_name": "Biriweb Serviços de Internet Ltd",
            "id": "d6db1129-0ed3-4da7-9beb-d8c6326465f2",
            "document_type": "cpf",
            "document_number": "12345678901"
          },
          "internal": true,
          "id": "3686155e-f5f6-4e5b-97e7-60473a506b8c",
          "currency": "BRL",
          "pix_info": null,
          "owner_document_type": null,
          "nickname": null,
          "intermediary_bank_account": null,
          "iban": null,
          "branch_number": null,
          "branch_country": null,
          "bank": {
            "swift": null,
            "name": "Internal",
            "ispb": null,
            "id": "6facab8d-573e-44d0-a4bd-ce2600368263",
            "country": "BRA",
            "code": "999"
          },
          "account_type": "conta-corrente",
          "account_number": null,
          "aba": null
        },
        "threeds_challenge": {
          "transaction_id": "bc897a32-f833-4208-811a-4cdb6119e168",
          "threeds_data": {
            "transaction_id_3ds": "daIar3L7pGeDGnvRr8b0",
            "three_ds_version": "2.1.0",
            "payload": "eyJtZXNzYWdlVHlwZSI6IkNSZXEiLCJtZXNzYWdlVmVyc2lvbiI6IjIuMS4wIiwidGhyZWVEU1NlcnZlclRyYW5zSUQiOiJhNGQ2M2RlNC05NTg0LTQxMWQtODYwZS1hYjljYjNlNTRmMTQiLCJhY3NUcmFuc0lEIjoiYjE2MjI3YjYtMWUzNy00ZmIzLWJmMzAtNWMwYzQzZjcxNjY0IiwiY2hhbGxlbmdlV2luZG93U2l6ZSI6IjAxIn0",
            "acs_url": "https://0merchantacsstag.cardinalcommerce.com/MerchantACSWeb/creq.jsp"
          },
          "jwt_challenge": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJPYmplY3RpZnlQYXlsb2FkIjp0cnVlLCJPcmdVbml0SWQiOiI2N2ExMTcwNGVhMTI3MDVmNzk2YTlkM2YiLCJQYXlsb2FkIjp7IkFDU1VybCI6Imh0dHBzOi8vMG1lcmNoYW50YWNzc3RhZy5jYXJkaW5hbGNvbW1lcmNlLmNvbS9NZXJjaGFudEFDU1dlYi9jcmVxLmpzcCIsIlBheWxvYWQiOiJleUp0WlhOellXZGxWSGx3WlNJNklrTlNaWEVpTENKdFpYTnpZV2RsVm1WeWMybHZiaUk2SWpJdU1TNHdJaXdpZEdoeVpXVkVVMU5sY25abGNsUnlZVzV6U1VRaU9pSmhOR1EyTTJSbE5DMDVOVGcwTFRReE1XUXRPRFl3WlMxaFlqbGpZak5sTlRSbU1UUWlMQ0poWTNOVWNtRnVjMGxFSWpvaVlqRTJNakkzWWpZdE1XVXpOeTAwWm1JekxXSm1NekF0TldNd1l6UXpaamN4TmpZMElpd2lZMmhoYkd4bGJtZGxWMmx1Wkc5M1UybDZaU0k2SWpBeEluMCIsIlRyYW5zYWN0aW9uSWQiOiJkYUlhcjNMN3BHZURHbnZScjhiMCJ9LCJSZXR1cm5VcmwiOiJodHRwOi8vMC4wLjAuMDo0MDAwL2FwaS92MS90cmFuc2FjdGlvbnMvYmM4OTdhMzItZjgzMy00MjA4LTgxMWEtNGNkYjYxMTllMTY4LzNkc19jYWxsYmFjayIsImlhdCI6MTc1MzM4ODg1MCwiaXNzIjoiNjdhMTE3MDUyN2NkZDIwNDk2ZDlmODkxIiwianRpIjoiZmI2N2JhN2EtMTg2My00ZGE4LWI0ZjMtNDRjZTFhZGVmZmFkIn0.pVoCMPHFGCnLL31v0y7YmjTqwKe1eJYkUfG3Iu4kIEk"
        },
        "subject_is_receiver": false,
        "subject_id": "6b724825-ce7e-4da2-9def-d75957fee745",
        "subject": {
          "updated_at": "2025-07-24T20:27:29.887571",
          "status": "reproved",
          "social_name": "Company Social Name LTDA",
          "rfc_pf": null,
          "required_clearance_level": 2,
          "references": [],
          "phone_number": "9876543210",
          "phone_country_code": "BR",
          "phone_area_code": "11",
          "net_monthly_average_income": "5000.00",
          "inserted_at": "2021-05-12T23:19:38.477358",
          "id": "6b724825-ce7e-4da2-9def-d75957fee745",
          "fiscal_country": "BR",
          "email": "biriweb@example.com",
          "document_type": "cpf",
          "document_number": "12345678909",
          "clearance_level": 1,
          "birth_date": "1985-08-31",
          "address_street": "Brazil test",
          "address_state": "SP",
          "address_postal_code": "1234567",
          "address_number": "123",
          "address_neighborhood": "Centro",
          "address_country": "BR",
          "address_complement": "Apt. 101",
          "address_city": "Sao Paulo"
        },
        "status": "pending",
        "source_name": "Company Social Name LTDA",
        "source_document_type": "cpf",
        "source_document_number": "12345678909",
        "payment_method": null,
        "meta": {
          "version": 2,
          "df_reference_id": "0_847562c4-87fb-4215-b4fb-90ca4d6aefdc",
          "mcc": "8999"
        },
        "inserted_at": "2025-07-24T20:27:29.867220",
        "id": "bc897a32-f833-4208-811a-4cdb6119e168",
        "from_credit_card": {
          "status": "not_tokenized",
          "inserted_at": "2025-07-24T20:27:29.866374",
          "id": "86e291b9-26bf-4252-a074-158ebe6464b6",
          "masked_card_number": "400000******1091"
        },
        "exchanged_value": "125.00",
        "from_bank_account": null,
        "for_exchange": false,
        "exchange_under_request": false,
        "exchange_currency": "BRL",
        "estimated_value_until_exchange": false,
        "currency": "BRL",
        "cleared": false,
        "bank_transaction": null
      }
    }
  },
  parameterPayload: [
    {
      name: "transaction",
      type: "object",
      required: true,
      description: "transaction data containing at least the following required values:"
    },
    {
      name: "transaction.currency",
      type: "string",
      required: true,
      description: "Origin currency"
    },
    {
      name: "transaction.exchange_currency",
      type: "string",
      required: true,
      description: "Destination currency"
    },
    {
      name: "transaction.value",
      type: "string",
      required: true,
      description: 'Total amount to be charged. Only numbers with exponent size 2 are allowed. (e.g.: "12.34").'
    },
    {
      name: "transaction.from_credit_card",
      type: "object",
      required: true,
      description: "Data containing at least the following required values:"
    },
    {
      name: "transaction.from_credit_card.card_number",
      type: "string",
      required: true,
      description: "The card number without spaces"
    },
    {
      name: "transaction.from_credit_card.card_expiration_date",
      type: "string",
      required: true,
      description: "Card expiration date in MM/YYYY format"
    },
    {
      name: "transaction.from_credit_card.card_brand",
      type: "string",
      required: true,
      description: 'Card brand, such as "visa", "mastercard", or "elo"'
    },
    {
      name: "transaction.from_credit_card.card_security_code",
      type: "string",
      required: true,
			description: "3-digit card security code"
    },
    {
      name: "transaction.from_credit_card.fullname",
      type: "string",
      required: true,
      description: "Cardholder's full name"
    },
    {
      name: "transaction.threeds",
      type: "object",
      required: true,
      description: "Data containing at least the following required values:"
    },
    {
      name: "transaction.threeds.softDescriptor",
      type: "string",
      required: false,
      description: `A short identifier (maximum of 13 characters) for the merchant that appears on the buyer’s credit card statement. All non-alphanumeric characters are removed, and the resulting value is concatenated with “*facilitapay”. If the descriptor exceeds 13 characters, it will be truncated. Examples: “airbnb” → “airbnb*facili”, “americanairlines” → “americanairli”`
    },
    {
      name: "transaction.threeds.httpAcceptBrowserValue",
      type: "string",
      required: true,
      description: "Value of the Accept Header of the Customer's browser."
    },
    {
      name: "transaction.threeds.httpBrowserLanguage",
      type: "string",
      required: true,
      description: "Customer's browser language according to https://www.techonthenet.com/js/language_tags.php"
    },
    {
      name: "transaction.threeds.httpBrowserJavaEnabled",
      type: "string",
      required: true,
      description: 'If Java is enabled on customer browser.\nOptions: "true", "false"'
    },
    {
      name: "transaction.threeds.httpBrowserJavaScriptEnabled",
      type: "string",
      required: true,
      description: 'If JavaScript is enabled on customer browser.\nOptions: "true", "false"'
    },
    {
      name: "transaction.threeds.httpBrowserColorDepth",
      type: "string",
      required: true,
      description: "Number of bits used to display images."
    },
    {
      name: "transaction.threeds.httpBrowserScreenHeight",
      type: "string",
      required: true,
      description: "Height of the Customer's screen resolution."
    },
    {
      name: "transaction.threeds.httpBrowserScreenWidth",
      type: "string",
      required: true,
      description: "Width of the Customer screen resolution."
    },
    {
      name: "transaction.threeds.httpBrowserTimeDifference",
      type: "string",
      required: true,
      description: "Difference in minutes between GMT time and that of the Customer's browser."
    },
    {
      name: "transaction.threeds.userAgentBrowserValue",
      type: "string",
      required: true,
      description: "The exact value of the User Agent Header."
    },
    {
      name: "transaction.threeds.ipAddress",
      type: "string",
      required: true,
      description: "It is the IP address of the Customer's device."
    },
    {
      name: "transaction.threeds.challengeWindowSize",
      type: "string",
      required: true,
      description: 'The size of the challenge window displayed to the shopper.\nOptions: "fullPage", "250x400", "390x400", "500x600", "600x400".'
    },
    {
      name: "transaction.to_bank_account_id",
      type: "string",
      required: true,
      description: "Partner internal bank account ID"
    },
    {
      name: "transaction.subject_id",
      type: "string",
      required: true,
      description: "The ID of the person or company involved in the transaction."
    },
    {
      name: "transaction.meta",
      type: "object",
      required: true,
      description: "Transaction metadata."
    },
    {
      name: "transaction.meta.version",
      type: "number",
      required: true,
      description: "Version of the API. Use the value 2."
    },
    {
      name: "transaction.meta.df_reference_id",
      type: "string",
      required: true,
      description: "Session ID generated after the DDC is completed."
    },
    {
      name: "transaction.meta.mcc",
      type: "string",
      required: true,
      description: 'Dynamic MCC. If you have multiple merchant category codes, the MCC lets you send a different merchant category code per transaction.\nOptions: "8999", "5045", "4722", "8299", "5947", "5065", "7372"'
    },
  ],
  domainsProperties: [
    { name: "4000000000001000", values: "Test Case 1: Successful Frictionless Authentication (Visa)" },
    { name: "5200000000001005", values: "Test Case 1: Successful Frictionless Authentication (Mastercard)" },
    { name: "4000000000001018", values: "Test Case 2: Failed Frictionless Authentication" },
    { name: "4000000000001026", values: "Test Case 3: Attempts Stand-In Frictionless Authentication" },
    { name: "4000000000001034", values: "Test Case 4: Unavailable Frictionless Authentication from the Issuer" },
    { name: "4000000000001042", values: "Test Case 5: Rejected Frictionless Authentication by the Issuer" },
    { name: "4000000000001059", values: "Test Case 6: Authentication Not Available on Lookup" },
    { name: "4000000000001067", values: "Test Case 7: Error on Lookup" },
    { name: "4000000000001075", values: "Test Case 8: Timeout on cmpi_lookup Transaction" },
    { name: "4000000000001091", values: "Test Case 10: Successful Step Up Authentication (Visa)" },
    { name: "5200000000001096", values: "Test Case 10: Successful Step Up Authentication (Mastercard)" },
    { name: "4000000000001109", values: "Test Case 11: Failed Step Up Authentication" },
    { name: "4000000000001117", values: "Test Case 12: Step Up Authentication is Unavailable" },
    { name: "4000000000001125", values: "Test Case 13: Error on Authentication" }
  ],
  important: [
    "From August 2025, this will be the default endpoint to create transactions. Check out the older version on “Credit card transactions Brazil (Deprecated)” section.",
    "A transaction with the status of `\"identified\"` means that the payment was approved without challenge.",
    "A transaction with the status of `\"pending\"` means that the payment is awaiting the challenge resolution. If the challenge was requested, but it is not completed within 5 minutes (i.e., timeout), the status is updated to `\"canceled\"`.",
    "A transaction with the status of `\"canceled\"` means that the payment was canceled by some reason, see the canceled_reason field on API response for more details.",
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/CreditCardBR.js